(function() {
  'use strict';

  function AnnouncementSlotController(
    $rootScope,
    RouterHelper,
    $scope,
    $uibModal,
    $translate,
    Announcements,
    Security,
    Notify,
    Utils,
    LocalizationService
  ) { // Replaced Router with RouterHelper
    var ctrl = this;

    var now = new Date();
    ctrl.today = now.toISOString();
    ctrl.dateFormat = LocalizationService.getDateTimeFormat('dateonly');
    ctrl.showLimit = 2;

    /**
     * We need this bound to the controller so that we can
     * either display the edit URL or just the announcement
     * title in the view.
     * @type {Boolean}
     */
    ctrl.canEditAnnouncement = false;
    ctrl.auditLogId = Utils.guid();

    Security.hasPermission('announcements.edit')
      .then(function(res) {
        ctrl.canEditAnnouncement = res === undefined ? true : res;
      });

    ctrl.actionButtons = [
      {
        label: $translate.instant('Edit'),
        icon: 'icon-edit',
        route: ['/announcements/edit', $scope.item._id],
        showCondition: Security.hasPermission.bind(this, 'announcements.edit'),
        klass: 'text-primary'
      },
      {
        label: $translate.instant('Delete'),
        icon: 'icon-trash',
        onClick: function() {
          Utils.swal({
            title: 'Are you sure you want to remove this announcement?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes'
          },
          function(isConfirm) {
            if (isConfirm) {
              var id = $scope.item._id;
              Announcements.remove(id)
                .then(function() {
                  $rootScope.$broadcast('KZItemRemoved', { item: $scope.item });
                  Notify.success('Announcement successfully removed!', 'Success');
                  RouterHelper.navigate(['/announcements']);
                });
            }
          });
        },
        showCondition: Security.hasPermission.bind(this, 'announcements.edit'),
        klass: 'text-danger'
      },
      {
        label: $translate.instant('Show audit log'),
        icon: 'icon-history',
        onClick: function() {
          ctrl.shownDescription = !ctrl.shownDescription;
          this.label = ctrl.shownDescription ? 'Hide audit log' : 'Show audit log';
          this.attrs['aria-expanded'] = ctrl.shownDescription ? 'true' : 'false';
        },
        showCondition: function() {
          return !_.isUndefined($scope.item.dates);
        },
        klass: 'text-info',
        attrs: {
          'aria-expanded': ctrl.shownDescription,
          'aria-controls': ctrl.auditLogId
        }
      }
    ];

    ctrl.secondaryActionButtons = [
      {
        label: $translate.instant('Preview'),
        icon: 'icon-view',
        onClick: function() {
          $uibModal.open({
            animation: true,
            size: 'md',
            templateUrl: 'app/components/announcements/preview.html',
            controller: 'AnnouncementPreviewController',
            controllerAs: 'announcementPreviewCtrl',
            resolve: {
              announcementDoc: function() {
                return $scope.item;
              },
              allowDismiss: function() {
                return false;
              },
              markAsRead: function() {
                return false;
              }
            }
          });
        },
        klass: 'text-info'
      }
    ];
  }

  function AnnouncementSlotDirective() {
    return {
      scope: {
        item: '=',
        onRemove: '&'
      },
      restrict: 'AE',
      templateUrl: 'app/components/announcements/directives/announcement.slot.html',
      controller: AnnouncementSlotController,
      controllerAs: 'ctrl'
    };
  }

  AnnouncementSlotController.$inject = [
    '$rootScope',
    'RouterHelperService',
    '$scope',
    '$uibModal',
    '$translate',
    'AnnouncementsService',
    'SecurityService',
    'NotifyService',
    'UtilsService',
    'LocalizationService'


  ];

  angular.module('component.announcements')
    .directive('announcementSlot', AnnouncementSlotDirective);
})();
